import { NgIf }                                              from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PushPipe }                     from '@ngrx/component';
import { BehaviorSubject, Subject }                          from 'rxjs';
import { map }                                               from 'rxjs/operators';
import { HeaderSelfcareParameters }                          from '../../../self-care/header-selfcare/header-selfcare-parameters';

const ELLIGIBLES = ['secu', 'gav', 'gso'];

@UntilDestroy()
@Component ({
              selector:        'app-header-preconisation-selfcare',
              templateUrl:     './header-preconisation-selfcare.component.html',
              styleUrls:       ['./header-preconisation-selfcare.component.scss'],
              changeDetection: ChangeDetectionStrategy.OnPush,
              standalone:      true,
              imports:         [
                PushPipe,
                NgIf,
              ],
            })
export class HeaderPreconisationSelfcareComponent implements OnInit {
  @Input () eligibites$: Subject<HeaderSelfcareParameters[]>;

  public uniqueGavSecuriteObseques$: BehaviorSubject<boolean>;

  constructor () {
    this.uniqueGavSecuriteObseques$ = new BehaviorSubject<boolean> (false);
  }

  ngOnInit (): void {
    const _self = this;
    _self.eligibites$.pipe (
      untilDestroyed (this),
      map (m => {
        const nbElligible = m.filter (m => m.value).map (m => m.key);
        if (nbElligible.length === 1 && ELLIGIBLES.includes (nbElligible[0])) {
          this.uniqueGavSecuriteObseques$.next (true);
        } else {
          this.uniqueGavSecuriteObseques$.next (false);
        }
      }),
    ).subscribe ();
  }

}
